<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "HeaderComponent",
  computed: {
    ...mapState(['sidebarOpen', 'wallet_address']), // 引入sidebarOpen状态
    connected() {
      if (this.wallet_address) {
        return this.wallet_address.substr(0, 6) + '...' + this.wallet_address.substr(-4)
      } else {
        return this.$t("connect"); // Correctly use this.$t for dynamic translation
      }
    }
  },
  methods: {
    ...mapMutations(['toggleSidebar']),
    ...mapActions(['connect_wallet', 'disconnect']), // 映射 actions
    switchLanguage() {
      this.$i18n.locale = this.$i18n.locale === 'en' ? 'zh' : 'en';
      localStorage.setItem('lang', this.$i18n.locale);
    },
    onClickMetamask: async function () {
      if (this.wallet_address) {
        this.disconnect()
      } else {
        await this.connect_wallet('metamask');
        this.isVisible = false;
      }
    },
  },
  mounted() {
    // this.onClickMetamask()
  }
}
</script>

<template>
  <div class="head">
    <div class="wrap">
      <div class="logo">
        <router-link to="/">AIR1</router-link>
      </div>
      <div class="right">
        <a href="javascript:" @click="switchLanguage" class="lan"></a>
        <a href="javascript:" @click="onClickMetamask" class="connect">{{ connected }}</a>
        <div class="menu" @click="toggleSidebar"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>